import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCToronto = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agency Toronto | AI UGC Creator Canada | Fuel72</title>
        <meta
          name="description"
          content="UGC Agency Toronto: Professional AI UGC videos for Canadian businesses. UGC Creator Toronto without influencers. 72-hour delivery. ✓ Local ✓ Fast ✓ Affordable"
        />
        <meta
          name="keywords"
          content="ugc agency toronto, ugc creator canada, ugc toronto, ai ugc canada, ugc videos toronto, content creator toronto, ugc advertising canada"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-toronto" />
        
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/ugc-toronto" />
        <link rel="alternate" hrefLang="en-CA" href="https://www.fuel72.com/ugc-toronto" />
        <link rel="alternate" hrefLang="x-default" href="https://www.fuel72.com/ugc-toronto" />
        
        <meta property="og:title" content="UGC Agency Toronto | AI UGC Creator Canada | Fuel72" />
        <meta property="og:description" content="AI UGC videos for Canadian businesses. Fast, professional, affordable." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-toronto" />
        <meta property="og:locale" content="en_CA" />
        
        <meta name="geo.region" content="CA-ON" />
        <meta name="geo.placename" content="Toronto" />
        <meta name="geo.position" content="43.6532;-79.3832" />
        <meta name="ICBM" content="43.6532, -79.3832" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agency Toronto",
            "description": "Professional AI UGC videos for Toronto and Canadian businesses. Create UGC content without filming.",
            "url": "https://www.fuel72.com/ugc-toronto",
            "telephone": "+4917687870011",
            "email": "hello@fuel72.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Toronto",
              "addressRegion": "ON",
              "addressCountry": "CA"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "43.6532",
              "longitude": "-79.3832"
            },
            "areaServed": { "@type": "City", "name": "Toronto" },
            "priceRange": "$$"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agency{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Toronto
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Professional AI UGC videos for Canadian businesses. 
            Retail, tech, hospitality – we make you visible.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC for Canadian Businesses</h2>
            <p className="text-muted-foreground">
              Toronto is Canada's business capital. With Fuel72, Canadian businesses get 
              professional UGC videos that perform on Instagram, TikTok and Meta Ads – 
              without expensive Toronto-based creators.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Industries in Toronto</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>🏦 Finance & Fintech</li>
              <li>🛍️ E-Commerce & Retail</li>
              <li>🍔 Restaurants & Food</li>
              <li>💪 Fitness & Health</li>
              <li>💇 Beauty & Wellness</li>
              <li>🚀 Tech Startups</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Why Fuel72 for Toronto?</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li>✅ <strong>Cheaper</strong> – $397 CAD instead of $600-2000 per creator</li>
              <li>✅ <strong>Faster</strong> – 72 hours instead of weeks</li>
              <li>✅ <strong>Scalable</strong> – Unlimited content production</li>
              <li>✅ <strong>No risk</strong> – Consistent quality every time</li>
            </ul>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Redirecting to main page...</p>
        </div>
      </main>
    </>
  );
};

export default UGCToronto;